"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksMappingEntityType = void 0;
var QuickBooksMappingEntityType;
(function (QuickBooksMappingEntityType) {
    QuickBooksMappingEntityType["Campaign"] = "campaign";
    QuickBooksMappingEntityType["Fund"] = "fund";
    QuickBooksMappingEntityType["AdditionalDonations"] = "additional_donations";
})(QuickBooksMappingEntityType || (exports.QuickBooksMappingEntityType = QuickBooksMappingEntityType = {}));
